import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { parse } from 'qs';
import { getUrlParamsString } from 'helpers/shared';
import OpeningsDirectoryIndex from './index';
import { getComponentState } from './reducer';
import { loadOpenings } from './actions';

const mapStateToProps = (state, ownProps) => {
  const params = parse(ownProps.location.search, { ignoreQueryPrefix: true, arrayLimit: 0 });
  return {
    accountSlug: ownProps.accountSlug,
    apiKeys: ownProps.apiKeys,
    brandSlug: ownProps.brandSlug,
    countryCode: ownProps.countryCode,
    embeddable: ownProps.embeddable,
    openings: getComponentState(state).openings,
    positions: getComponentState(state).positions,
    stateCodes: getComponentState(state).stateCodes,
    pagination: getComponentState(state).pagination,
    urlParams: getUrlParamsString(),
    params,
    preview: ownProps.preview,
    ui: getComponentState(state).ui,
    viewText: ownProps.translations.view,
  };
};

const mapDispatchToProps = { loadOpenings };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OpeningsDirectoryIndex));
